import * as $ from "jquery";
import imkt from '../../../imkt';
import tracking from '../../../utils/tracking';
import tlds from 'tlds';
import 'jquery-validation';
import '@types/jquery.validation';

var cst = window.cst || (window.cst = {});

var FILE_SIZE_LIMIT = 26214400; //25MB
var FILE_SIZE_LIMIT_DISPLAY = (FILE_SIZE_LIMIT / 1024 / 1024).toFixed(0);

var $formSection = $(".wac-form--billing-licensing");
var STICKYNAV_HEIGHT = $("#companynav").outerHeight();

/********************
   Custom AUI validators for conditional forms.
   These validators do not invalidate if the field is hidden by our conditional form framework.
   ********************/

/**
 * data-aui-validation-cst-required
 *
 * clone of the standard aui "required" validator
 */
/* jshint -W117 */
AJS.formValidation.register(["cst-required"], function (field) {
  var value = $.trim(field.el.value);
  if (!$(field.el).prop("disabled") && value.length === 0) {
    field.invalidate("This is a required field");
  } else {
    field.validate();
  }
});

/**
 * data-aui-validation-cst-minlength
 *
 * validate that the field has a minimum number of characters to validate
 */
AJS.formValidation.register(["cst-minlength"], function (field) {
  var value = $.trim(field.el.value),
    arg = parseInt(field.args("cst-minlength"));
  if (!$(field.el).prop("disabled") && arg && value.length < arg) {
    field.invalidate(
      AJS.format("Input has minimum length of {0} characters", arg)
    );
  } else {
    field.validate();
  }
});

/**
 * data-aui-validation-cst-filesize
 *
 * For HTML 5 capable browsers, check the filesize of file attachements
 */
AJS.formValidation.register(["cst-filesize"], function (field) {
  if (field.el && !$(field.el).prop("disabled") && field.el.files) {
    var files = field.el.files;
    if (files.length > 0) {
      var fileSize = files[0].size;
      if (fileSize > FILE_SIZE_LIMIT) {
        field.invalidate(
          "Maximum attachment size is " + FILE_SIZE_LIMIT_DISPLAY + " MB"
        );
      }
    }
  }
  field.validate();
});

// validate email address
AJS.formValidation.register(["cst-email"], function (field) {
  var emailAddress = $.trim(field.el.value).trim(),
    pattern = cst.support.forms[field.args("cst-email")];
  if (
    !$(field.el).prop("disabled") &&
    pattern &&
    (!validEmailAddressAndUser(pattern, emailAddress) ||
    !isTldsValidated(emailAddress))
  ) {
    field.invalidate(AJS.format("Invalid Email address"));
  } else {
    field.validate();
  }
});

// This logic has been taken from JSD com.atlassian.servicedesk.internal.feature.emailchannel.EmailUtil.java
function validEmailAddressAndUser(pattern: RegExp, emailAddress: string) {
  if (pattern.test(emailAddress)) {
    var userName = emailAddress.split("@")[0];
    // we do not allow .foo or foo. or foo..foo username in the email as per JSD restriction so email address with any of these username will be invalid
    return (
      !/^[.]/.test(userName) &&
      !/.*[.]$/.test(userName) &&
      !/.*?[.]{2,}.*$/.test(userName)
    );
  }
  return false;
}

// validate tlds
function isTldsValidated(emailAddress: string) {
  const actualTld = emailAddress.slice(emailAddress.lastIndexOf('.') + 1);
  return tlds.includes(actualTld);
}

function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

var isMobile = function () {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

var generalMessageControl = function (mode) {
  var generalMessage = $("#jq_general_message");
  if (mode == "hide") {
    generalMessage.hide();
    generalMessage.find(":input").val("");
    disableFields(generalMessage);
  } else {
    generalMessage.show();
    enableFields(generalMessage);
  }
};

// these map keys come from the "data-product" attributes on the evaluator advice form
var productMap = {
  default: {
    recommended_by: "Tim",
    avatar: "img/placeholder.png",
    demo_url: "http://www.youtube.com/user/GoAtlassian",
    trial_url: "http://www.atlassian.com/software",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  jira_software: {
    recommended_by: "Aaron",
    avatar: "img/placeholder.png",
    demo_url: "http://www.atlassian.com/software/jira/demo/",
    trial_url: "http://www.atlassian.com/software/jira/try",
    rfp_help_url:
      "https://confluence.atlassian.com/display/JIRAKB/RFI+for+JIRA+and+JIRA+Agile",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  jira_service_desk: {
    recommended_by: "Will ",
    avatar: "img/placeholder.png",
    webinar_url:
      "http://www.atlassian.com/software/jira/service-desk/demo?partnerref=pa-form",
    trial_url: "http://www.atlassian.com/software/jira/service-desk/try",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  jira_core: {
    recommended_by: "Matt",
    avatar: "img/placeholder.png",
    demo_url: "http://blogs.atlassian.com/2015/10/say-hello-jira-core/",
    trial_url: "http://www.atlassian.com/software/jira/core/try",
    rfp_help_url:
      "https://confluence.atlassian.com/display/JIRAKB/RFI+for+JIRA+and+JIRA+Agile",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  jira_portfolio: {
    recommended_by: "Aaron",
    avatar: "img/placeholder.png",
    webinar_url:
      "https://www.atlassian.com/software/jira/portfolio/demo-video?partnerref=pa-form",
    trial_url:
      "http://marketplace.atlassian.com/plugins/com.radiantminds.roadmaps-jira/cloud/overview",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  confluence: {
    recommended_by: "Zu",
    avatar: "img/placeholder.png",
    demo_url: "http://www.atlassian.com/software/confluence/demo/",
    trial_url: "https://www.atlassian.com/software/confluence/try",
    rfp_help_url:
      "https://confluence.atlassian.com/display/CONFKB/RFI+for+Confluence",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  bitbucket: {
    recommended_by: "Malik",
    avatar: "img/placeholder.png",
    demo_url: "http://www.youtube.com/user/GoAtlassian/search?query=bitbucket",
    trial_url: "http://www.atlassian.com/software/bitbucket/download/",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  sourcetree: {
    recommended_by: "Malik",
    avatar: "img/placeholder.png",
    demo_url: "http://www.atlassian.com/software/sourcetree/overview",
    trial_url: "http://www.sourcetreeapp.com",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  bamboo: {
    recommended_by: "Malik",
    avatar: "img/placeholder.png",
    demo_url: "http://www.youtube.com/user/GoAtlassian/search?query=bamboo",
    trial_url: "https://www.atlassian.com/software/bamboo/download",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  clover: {
    recommended_by: "Malik",
    avatar: "img/placeholder.png",
    demo_url: "http://www.atlassian.com/software/clover/overview",
    trial_url: "http://www.atlassian.com/software/clover/download",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  fisheye: {
    recommended_by: "Malik",
    avatar: "img/placeholder.png",
    demo_url: "http://www.atlassian.com/software/fisheye",
    trial_url: "http://www.atlassian.com/software/fisheye/download",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
  crucible: {
    recommended_by: "Malik",
    avatar: "img/placeholder.png",
    demo_url: "http://www.atlassian.com/software/crucible/",
    trial_url: "http://www.atlassian.com/software/crucible/download",
    tech_support_url: "https://support.atlassian.com/contact/",
  },
};

var selfHelpMarginCalc = 0;

function moveSlider(marginCalc: number) {
  $("#kt_test_slider_content").animate(
    { "margin-left": marginCalc + "%" },
    450,
    "swing"
  );
}

var handleSlideNext = function (jqTarget: JQuery<HTMLElement>) {
  handleSlideNextState(jqTarget);

  var slide = jqTarget.parents(".kt_test_slide");

  if (slide.is("#kt_test_slide_1")) {
    selfHelpMarginCalc -= 200;
    moveSlider(selfHelpMarginCalc);
    $("#kt_test_help_slider_crop").addClass("show-content");
    slide.children().fadeOut("fast");
    $("#kt_test_slide_2").children().show();
  }

  if (slide.is("#kt_test_slide_3")) {
    if (
      $("#kt_test_slide_4").children(".kt_test_sub_level:visible").length < 1
    ) {
      selfHelpMarginCalc -= 100;
      moveSlider(selfHelpMarginCalc);
    }
  }

  jqTarget.addClass("selected");
  jqTarget.siblings(".selected").removeClass("selected");

  jqTarget
    .parents(".kt_test_slide")
    .nextAll(".kt_test_slide")
    .find(".kt_test_sub_level")
    .hide();

  if (typeof sub_level === "undefined") {
    var sub_level;
  }
  sub_level = jqTarget.attr("rel");
  $("#kt_test_show_" + sub_level).fadeIn();
};

var handleSlideBack = function (jqTarget: JQuery<HTMLElement>) {
  var selfHelpLevel = jqTarget
    .closest("[data-selfhelp-level]")
    .data("selfhelpLevel");
  handleSlideBackState(selfHelpLevel);

  var slide = jqTarget.parents(".kt_test_slide");

  if (slide.is("#kt_test_slide_2")) {
    selfHelpMarginCalc += 200;
    moveSlider(selfHelpMarginCalc);
    $("#kt_test_help_slider_crop").removeClass("show-content");
    $("#kt_test_slide_1").children().delay(200).fadeIn();
    $("#kt_test_slide_2").children().hide();
  }

  if (slide.is("#kt_test_slide_3")) {
    if ($("#kt_test_slide_4").children(".kt_test_sub_level:visible").length) {
      selfHelpMarginCalc += 100;
      moveSlider(selfHelpMarginCalc);
    }
  }

  if (slide.is("#kt_test_slide_4")) {
    selfHelpMarginCalc += 100;
    moveSlider(selfHelpMarginCalc);
  }

  jqTarget.parents(".kt_test_sub_level").fadeOut();
  jqTarget
    .parents(".kt_test_slide")
    .nextAll(".kt_test_slide")
    .find(".kt_test_sub_level")
    .fadeOut();

  // clear out all selections for higher levels
  for (var i = selfHelpLevel; i <= 4; i++) {
    $("[data-selfhelp-level='" + i + "'] a.kt_test_slide_next").removeClass(
      "selected"
    );
  }
};

/**
 * Maps self help key + reporter status to reason
 */
var selfHelpReasonMap = {
  "help_tax_exemptions|customer_no": "tax_exemptions",
  "help_new_quote|customer_no": "request_quote",
  "help_new_quote|reseller": "request_quote",
  "help_change_quote|customer_no": "edit_quote",
  "help_change_quote|reseller": "edit_quote",
  "help_renewal_quote|reseller": "renew_quote",
  "help_upgrade_quote|reseller": "change_user_tier",
  "help_make_payment|customer_no": "how_to_purchase",
  "help_make_payment|reseller": "process_payment",
  "help_purchase_from_trial|customer_yes": "process_payment",
  "help_purchase_from_trial|reseller": "process_payment",
  "help_problems_payment|customer_no": "how_to_purchase",
  "help_invoices|reseller": "request_invoice",
  "help_upgrade_user_tier|reseller": "change_user_tier",
  "help_change_contact|reseller": "update_contacts",
  "help_extend_trial|customer_no": "extend_trial",
};

var selfHelpState;
var selfHelpStateStack;

var resetSelfHelpState = function () {
  selfHelpState = {
    formOverride: "",
    selfHelpKey: "",
    reason: "",
    reporterStatus: "",
    reporterStatusUnchecked: "",
    hosting: "",
    selfHelpPath: [],
    selfHelpLabels: [],
  };
  selfHelpStateStack = [];
  selfHelpStateStack.push(clone(selfHelpState));
};

/**
 * Tie in pick-a-path self-help to form through selfHelpState
 */
var handleSlideNextState = function (jqTarget: JQuery<HTMLElement>) {
  var selfHelpLevel = jqTarget
    .closest("[data-selfhelp-level]")
    .data("selfhelpLevel");
  var nodeKey = jqTarget.attr("rel");

  // slideNext also gets invoked for siblings. Visiting siblings should invoke a state slideback first.
  if (selfHelpState.selfHelpPath.length == selfHelpLevel) {
    handleSlideBackState(selfHelpLevel + 1);
  }

  // check if this node adds labels
  if (typeof jqTarget.data("label") !== "undefined") {
    selfHelpState.selfHelpLabels.push(jqTarget.data("label"));
  }

  // check if the node sets a reporter_status
  if (typeof jqTarget.data("reporterStatus") !== "undefined") {
    selfHelpState.reporterStatus = jqTarget.data("reporterStatus");
  }

  // check if the node sets reporter-status-unchecked
  if (typeof jqTarget.data("reporterStatusUnchecked") !== "undefined") {
    selfHelpState.reporterStatusUnchecked = jqTarget.data(
      "reporterStatusUnchecked"
    );
  }

  // check if the node sets reason
  if (typeof jqTarget.data("reason") !== "undefined") {
    selfHelpState.reason = jqTarget.data("reason");
    selfHelpState.selfHelpKey = nodeKey;
  }

  // check if the node sets hosting
  if (typeof jqTarget.data("hosting") !== "undefined") {
    selfHelpState.hosting = jqTarget.data("hosting");
  }

  // push this self help node onto the full path
  selfHelpState.selfHelpPath.push(nodeKey);

  // copy state onto stack so we can go backwards
  selfHelpStateStack.push(clone(selfHelpState));
};

// Undo things that were set by moving forward in self help
var handleSlideBackState = function (selfHelpLevel) {
  var backIndex = selfHelpStateStack.length - selfHelpLevel + 1;
  for (var i = 0; i < backIndex; i++) {
    selfHelpStateStack.pop();
  }
  selfHelpState = clone(selfHelpStateStack[selfHelpStateStack.length - 1]);
};

var resetSelfHelp = function () {
  resetSelfHelpState();
  selfHelpMarginCalc = -200;
  handleSlideBack($("#kt_test_slide_2").find(".kt_test_slide_back"));
};

var simulateClickReasonMenuLink = function (reasonMenu, reason) {
  var reasonLink = $(
    "[data-select-option-id='" +
      reasonMenu +
      "'] a[data-fake-select-value='" +
      reason +
      "']"
  );
  var simulatedClick = true;
  reasonLink.trigger("click", simulatedClick);
};

var setSelfHelpFormSelections = function (
  selfHelpKey,
  reporterStatus,
  reason,
  reporterStatusUnchecked
) {
  // if self help reason is supplied, then just use it, no need to look anything up
  // otherwise reason is based on self help key and reporter status
  if (!reason) {
    var reasonKey = selfHelpKey + "|" + reporterStatus;

    reason = selfHelpReasonMap[reasonKey];

    if (!reason) {
      // the default reason
      reason = "other_queries";
    }
  }

  var triggeredReporterRadio = $(
    "input[name='reporter_status'][value=" + reporterStatus + "]"
  );
  var selector = triggeredReporterRadio.parents("[data-selector-level]");
  var optionSelectorLevel = selector.data("selectorLevel");

  // simulate reporter_status selection. Normally this pops open the reason menu, but in this case we want it to stay closed.
  var reasonMenu = $("[data-select-option-id='" + reporterStatus + "']");
  reasonMenu.data("disableAutoOpen", true);
  handleConditionalFormSelect(
    triggeredReporterRadio,
    reporterStatus,
    optionSelectorLevel
  );
  reasonMenu.data("disableAutoOpen", false);

  if (!reporterStatusUnchecked) {
    triggeredReporterRadio.prop("checked", true);
  }

  // simulate reason selection
  simulateClickReasonMenuLink(reporterStatus, reason);

  // set hosting if any
  if (selfHelpState.hosting) {
    $(
      "input[type='radio'][name='hosting'][value='" +
        selfHelpState.hosting +
        "']:visible"
    )
      .prop("checked", true)
      .trigger("click");
  }
};

var selfHelpContactUs = function () {
  // changes how the normal conditional forms framework behaves
  selfHelpState.formOverride = true;

  // clear reporter_status which may have been set previously
  $("input[name='reporter_status']").prop("checked", false);

  setSelfHelpFormSelections(
    selfHelpState.selfHelpKey,
    selfHelpState.reporterStatus,
    selfHelpState.reason,
    selfHelpState.reporterStatusUnchecked
  );
};

var doAlternateSelfHelpBehavior = function (selectedValue) {
  if (selectedValue == selfHelpState.reporterStatus) {
    // set just like original form selection
    setSelfHelpFormSelections(
      selfHelpState.selfHelpKey,
      selfHelpState.reporterStatus,
      selfHelpState.reason
    );
  } else {
    // set based on selfHelpKey map
    setSelfHelpFormSelections(selfHelpState.selfHelpKey, selectedValue);
  }
};

// event handler to add self-help stuff to form at submit time
$("form.jq_conditional_form").on("final-submit", function () {
  var form = $(this);

  // add self-help path if any
  if (selfHelpState.selfHelpPath.length > 0) {
    var pathString = "";
    $.each(selfHelpState.selfHelpPath, function (index, value) {
      pathString += value;
      if (index < selfHelpState.selfHelpPath.length - 1) {
        pathString += " > ";
      }
    });
    cst.support.forms.addFormData(
      form,
      "selfhelp_path",
      pathString,
      "Self Help Path"
    );
  }

  // add additional labels to form reason field if any
  if (selfHelpState.selfHelpLabels.length > 0) {
    // var reasonField = jqThis.find("input[name='reason']");
    // var reasonFieldValue = reasonField.val();
    $.each(selfHelpState.selfHelpLabels, function (index, value) {
      // adding this way creates an array of values in request params
      cst.support.forms.addFormData(form, "reason", value);
    });
    // reasonField.val(reasonFieldValue);
  }
});

var disableField = function (jqField) {
  var origDisabledVal = jqField.prop("disabled");
  jqField.attr("orig-disabled", origDisabledVal);
  jqField.prop("disabled", "true");
};

var disableFields = function (jqElem) {
  jqElem.find(":input").each(function () {
    disableField($(this));
  });
};

var enableField = function (jqField) {
  var origDisabledVal = jqField.attr("orig-disabled");
  jqField.removeAttr("orig-disabled");
  // set to true if the original value was true, else false
  jqField.prop("disabled", origDisabledVal == "true");
};

var enableFields = function (jqElem) {
  jqElem.find(":input").each(function () {
    enableField($(this));
  });
};

var resetFakeSelect = function (fakeSelect) {
  var fakeSelectField = fakeSelect.find(".jq_fake_select_field");
  var fakeSelectInput = fakeSelect.find(".jq_fake_select_input");
  var fakeSelectOptions = fakeSelect.find(".jq_fake_select_options");
  fakeSelectField.html(fakeSelectField.data("defaultValue"));
  fakeSelectInput.val("");
  closeFakeSelectOptions(fakeSelectOptions);
};

var archiveAndChangeHtml = function (jqNodes, newHtml) {
  jqNodes.each(function () {
    var jqThis = $(this);
    var origHtml = jqThis.data("originalHtml");
    if (!origHtml) {
      origHtml = jqThis.html();
      jqThis.attr("data-original-html", origHtml);
    }
    jqThis.html(newHtml);
  });
};

var restoreHtml = function (jqNodes) {
  jqNodes.each(function () {
    var jqThis = $(this);
    var origHtml = jqThis.data("originalHtml");
    if (origHtml) {
      jqThis.html(origHtml);
    }
  });
};

/**
 * The main function of the conditional forms. Handles showing and hiding of conditional form sections.
 * @param option_selected The dom element that was selected.
 * @param option_selected_value The value associated with that dom element. Passed in separately because this is also
 * used with pseudo selectors that are not real html select elements.
 */
var handleConditionalFormSelect = function (
  option_selected,
  option_selected_value,
  selectorLevel
) {
  /* Save the text in the current comments and instance identifier fields before swapping the form out */
  var currentCommentsField = $("[data-persist-comments=true]:visible");
  var persistedComments = currentCommentsField.val();

  var currentInstanceIdentifierField = $(
    "input[name=instance_identifier]:visible"
  );
  var persistedInstanceIdentifier = currentInstanceIdentifierField.val();

  var solvvyDisclaimer = $("#solvvy-disclaimer");
  var formSubmitButton = $("#jq_form_submit");
  if (option_selected_value === "sourcetree_customer") {
    solvvyDisclaimer.hide();
    formSubmitButton.hide();
    disableFields(solvvyDisclaimer, formSubmitButton);
  } else {
    solvvyDisclaimer.show();
    formSubmitButton.show();
    enableFields(solvvyDisclaimer, formSubmitButton);
  }

  var getMaxSelectedLevel = function (elem) {
    var maxLevel = -1;
    $(elem)
      .find("[data-selected-level]")
      .each(function () {
        var selectedLevel = $(this).data("selectedLevel");
        if (selectedLevel > maxLevel) {
          maxLevel = selectedLevel;
        }
      });
    return maxLevel;
  };

  /**
   * de-select and hide any existing selections for that level and higher levels, also clear form inputs within the existing selections,
   * also show the general message if a replacer is contained in any higher levels
   */
  var maxSelectedLevel = getMaxSelectedLevel(document);
  for (var i = selectorLevel; i <= maxSelectedLevel; i++) {
    var existingSelection = $("[data-selected-level=" + i + "]").removeAttr(
      "data-selected-level"
    );
    // suppress jshint warning
    /* jshint -W083 */
    existingSelection.find(":input").each(function () {
      var jqThis = $(this);
      var inputType = jqThis.attr("type");
      if (inputType == "radio" || inputType == "checkbox") {
        jqThis.prop("checked", false);
      } else if (jqThis.is("select")) {
        if (jqThis.hasClass("select2-offscreen")) {
          jqThis.select2("val", "");
        } else {
          this.selectedIndex = -1;
        }
      } else {
        jqThis.val("");
      }

      // disable fields that are conditionally hidden
      disableField(jqThis);
    });

    existingSelection.find(".jq_fake_select").each(function () {
      resetFakeSelect($(this));
    });

    // hide any inline dialogs
    existingSelection.find("aui-inline-dialog").css("display", "none");
    existingSelection.hide();
    existingSelection.trigger("conditional-hide");

    if (
      existingSelection.find("textarea[name='comments']").length ||
      existingSelection.is(".jq_replace_general_message")
    ) {
      generalMessageControl("show");
    }
  }

  /**
   * select and fade in the new html section for that level.
   */
  // due to multiple inputs that have the same values, had to introduce this data-selected-value attr to disambiguate
  option_selected_value =
    option_selected.data("selectedValue") || option_selected_value;

  /**
   * Add exceptions here that don't follow the normal selection rules.
   */
  // product evaluator enterprise exceptions
  var selectedProduct = $("input[name='product']").val();
  if (
    selectedProduct == "tam" ||
    selectedProduct == "priority_support" ||
    selectedProduct == "premier_support"
  ) {
    if (option_selected_value == "eval") {
      // skip the inquiry_category selector and go straight to enterprise_eval
      option_selected_value = "enterprise_eval";
    } else if (option_selected_value == "pre_eval") {
      // don't show any conditional fields
      option_selected_value = "enterprise_pre_eval";
    }
  }

  // products with hosting options
  var selectedEvalStage = $("input[name='evaluation_stage']:checked").val();
  var product_whitelist = [
    "confluence",
    "jira_software",
    "jira_service_desk",
    "jira_core",
    "jira_portfolio",
    "bitbucket",
  ];
  var eval_stage_whitelist = ["eval", "pre_eval"];
  if (
    product_whitelist.indexOf(selectedProduct) !== -1 &&
    eval_stage_whitelist.indexOf(selectedEvalStage) !== -1
  ) {
    var hostingOptionSection = $(
      "#hosting_option_section_" + selectedEvalStage
    );

    enableFields(hostingOptionSection);
    hostingOptionSection.show();

    if (selectedProduct == "jira_core" || selectedProduct == "jira_portfolio") {
      hostingOptionSection.find(".hosting_option_section_dc").hide();
      hostingOptionSection.find(".hosting_option_section_cloud").show();
    } else {
      hostingOptionSection
        .find(".hosting_option_section_cloud, .hosting_option_section_dc")
        .show();
    }
  } else {
    var allHostingOptionSections = $("[data-level-id=hosting_option]");
    disableFields(allHostingOptionSections);
    allHostingOptionSections.hide();
  }

  var selectedSection = $(
    "[data-select-option-id=" + option_selected_value + "]"
  );
  selectedSection.attr("data-selected-level", selectorLevel);
  selectedSection.find(":input").each(function () {
    var jqThis = $(this);
    if (jqThis.is("[type='radio']") || jqThis.is("[type='checkbox']")) {
      jqThis.prop("checked", jqThis.data("default") == "checked");
    }

    // re-enable fields that are conditionally shown
    enableField(jqThis);
  });

  if (
    selectedSection.find("textarea[name='comments']").length ||
    selectedSection.is(".jq_replace_general_message")
  ) {
    generalMessageControl("hide");
  }

  selectedSection.trigger("conditional-show");
  selectedSection.fadeIn();

  /*
   * New conditional form is showing, we can select the new fields and populate it with the persisted values
   * Setting input value in JS doesn't trigger 'change' event automatically, we call it manually to hide any fake placeholders
   */
  if (persistedComments) {
    var newCommentsField = $("[data-persist-comments=true]:visible");
    newCommentsField.val(persistedComments).trigger("change");
  }

  if (persistedInstanceIdentifier) {
    var newInstanceIdentifierField = $(
      "input[name=instance_identifier]:visible"
    );
    newInstanceIdentifierField
      .val(persistedInstanceIdentifier)
      .trigger("change");
  }
};

var toggleFakeSelectOptions = function (fakeSelectOptions) {
  fakeSelectOptions.slideToggle("fast");
};
var openFakeSelectOptions = function (fakeSelectOptions) {
  fakeSelectOptions.slideDown("fast");
};
var closeFakeSelectOptions = function (fakeSelectOptions) {
  fakeSelectOptions.slideUp("fast");
};

/**
 * on ready
 */
$(document).ready(function () {
  resetSelfHelpState();
  // Let's fetch again so the next trigger would have the correct LC state

  /**
   * Spam prevention
   *  - hp-field-email fields are hidden by jquery and should always have value name@email.com
   *  - hp-field-value fields are hidden by css and should always have empty value
   * Spam form submissions are submitted as usual and then flagged and processed as spam on server side
   */
  var emailElem = $(".jq_conditional_form #email");
  emailElem.before(
    "<div class='info-wrap hp-field-email'><div class='left-side'><label for='customer_email'>Your email address</label></div><div class='right-side'><input id='customer_email' type='email' name='customer_email' placeholder='name@email.com'></div></div>"
  );
  emailElem.before(
    "<div class='info-wrap hp-field-value'><div class='left-side'><label for='product_name'>Product name</label></div><div class='right-side'><input id='product_name' type='text' name='product_name'></div></div>"
  );

  $(".hp-field-email").hide();
  $(".hp-field-email input[type=email]").val("name@email.com");

  // make columns on main Contact page link to button href
  if (!imkt.isEditMode) {
    var columnLink = $(".column__support-portal-link");
    if (columnLink.length) {
      columnLink.click(function () {
        window.location = $(this).find("a.button").attr("href");
        return false;
      });
    }
  }

  /**
   * disable all conditional fields. These will be enabled by conditional form logic if they need to be.
   */
  var conditionalFields = $("[data-select-option-id] :input");
  conditionalFields.each(function () {
    disableField($(this));
  });

  /**
   * Replace select fields marked with 'selectReplace' class with select2 widget
   */
  var selector = $(".selectReplace");
  if (selector.length) {
    if (!isMobile()) {
      // replace with select2
      $.getScript(
        imkt.constants.libPath + "select2.js" + imkt.constants.cdnVersionQuery
      ).done(function () {
        selector.select2({
          minimumResultsForSearch: Infinity,
        });
      });
    } else {
      // make sure real select is displayed if not in conditional section
      selector.find("option").css("display", "inline");
      selector.css("display", "inline");
    }
  }

  /**
   * Set up the conditional form event handlers for different input types
   */
  $("select[data-selector-level]").on("change", function (e, simulated) {
    var jqThis = $(this);
    var selector = jqThis;
    var optionSelected = jqThis.find(":selected");
    // conditional form selector value can be set in html via "data-selector-value", which takes precedence, or natural input value
    var optionSelectedValue;
    if (optionSelected.is("[data-selector-value]")) {
      optionSelectedValue = optionSelected.data("selectorValue");
    } else {
      optionSelectedValue = optionSelected.val();
    }
    var optionSelectorLevel = selector.data("selectorLevel");
    if (
      !simulated &&
      selector.data("selfhelpReset") &&
      selfHelpState.formOverride
    ) {
      resetSelfHelp();
    }
    handleConditionalFormSelect(
      optionSelected,
      optionSelectedValue,
      optionSelectorLevel
    );
  });

  $("[data-selector-level] input[type='radio']").on(
    "click",
    function (e, simulated) {
      var jqThis = $(this);

      var selector = jqThis.parents("[data-selector-level]");
      var optionSelected = selector.find("input:checked");
      // conditional form selector value can be set in html via "data-selector-value", which takes precedence, or natural input value
      var optionSelectedValue;
      if (optionSelected.is("[data-selector-value]")) {
        optionSelectedValue = optionSelected.data("selectorValue");
      } else {
        optionSelectedValue = optionSelected.val();
      }

      var optionSelectorLevel = selector.data("selectorLevel");
      if (
        !simulated &&
        selector.data("selfhelpReset") &&
        selfHelpState.formOverride
      ) {
        resetSelfHelp();
      }

      // if selector has alternateSelfHelpBehavior, do that action here
      if (
        selector.data("alternateSelfhelpBehavior") &&
        selfHelpState.formOverride
      ) {
        doAlternateSelfHelpBehavior(optionSelectedValue);
      } else {
        // do normal conditional form behavior
        handleConditionalFormSelect(
          optionSelected,
          optionSelectedValue,
          optionSelectorLevel
        );
      }
    }
  );

  $(".jq_fake_select[data-selector-level] .jq_fake_select_options a").on(
    "click",
    function (e, simulated) {
      e.preventDefault();

      var jqThis = $(this);
      var selector = jqThis.parents("[data-selector-level]");
      var optionSelected = jqThis;
      // conditional form selector value can be set in html via "data-selector-value", which takes precedence, or natural input value
      var optionSelectedValue;
      if (optionSelected.is("[data-selector-value]")) {
        optionSelectedValue = optionSelected.data("selectorValue");
      } else {
        optionSelectedValue = optionSelected.attr("rel");
      }
      var optionSelectorLevel = selector.data("selectorLevel");
      if (
        !simulated &&
        selector.data("selfhelpReset") &&
        selfHelpState.formOverride
      ) {
        resetSelfHelp();
      }
      handleConditionalFormSelect(
        optionSelected,
        optionSelectedValue,
        optionSelectorLevel
      );
    }
  );

  /**
   * Set up fake select event handlers
   */

  // toggle fake select options
  $(".jq_fake_select_field").click(function () {
    var fakeSelectOptions = $(this)
      .parents(".jq_fake_select")
      .find(".jq_fake_select_options");
    toggleFakeSelectOptions(fakeSelectOptions);
  });

  // close fake select on click outside
  $(document).mouseup(function (e) {
    var fakeSelect = $(".jq_fake_select");

    // if click not in fake_selector
    if (!fakeSelect.is(e.target) && fakeSelect.has(e.target).length === 0) {
      var fakeSelectOptions = fakeSelect.find(".jq_fake_select_options");
      closeFakeSelectOptions(fakeSelectOptions);
    }
  });

  // handle fake select selection
  $(".jq_fake_select .jq_fake_select_options a").click(function (e) {
    e.preventDefault();

    var selectedOption = $(this);
    var fakeSelect = selectedOption.parents(".jq_fake_select");
    var fakeSelectField = fakeSelect.find(".jq_fake_select_field");
    var fakeSelectOptions = fakeSelect.find(".jq_fake_select_options");
    var fakeSelectInput = fakeSelect.find("input.jq_fake_select_input");
    var selectedOptionText = selectedOption.html();
    var selectedOptionValue = selectedOption.data("fakeSelectValue");

    // if default value of this fake field has not been set, then set it
    if (!fakeSelectField.data("defaultValue")) {
      fakeSelectField.attr("data-default-value", fakeSelectField.html());
    }

    // set fake field to chosen value and close the options
    fakeSelectField.addClass("populated").html(selectedOptionText);
    fakeSelectInput.val(selectedOptionValue);
    fakeSelectOptions.fadeOut("fast");
  });

  /**
   * Fake placeholder
   */
  $(".jq_fake_placeholder").on("keyup change", function () {
    if (this.value.length > 0) {
      $(this).css("background-color", "#fff");
    } else {
      $(this).css("background-color", "transparent");
    }
  });

  $(".jq_toggle_self_service_instructions").click(function (e) {
    e.preventDefault();
    var instructions = $(this).next(".jq_self_service_instructions");

    instructions.toggle();
  });

  /*******************************
   * Purchasing and Licensing Form
   *******************************/

  /**
   * Handle the "reason" fake select field and make it drop down automatically.
   */
  $("[data-select-option-id]:has(input[name='reason'])").on(
    "conditional-show",
    function () {
      var jqThis = $(this);

      if (!jqThis.data("disableAutoOpen")) {
        // open the fake selector options
        openFakeSelectOptions(jqThis.find(".jq_fake_select_options"));
      }
    }
  );

  //TODO: replace with AUI required field?
  /**
   * Force selection before allowing form submit.
   */
  $(
    "#jq_choose_customer_yes a, #jq_choose_customer_no a, #jq_choose_reseller a"
  ).click(function () {
    $(".js-form-submit-disabled").removeClass("js-form-submit-disabled");
    $(".form-submit-disabled").removeClass("form-submit-disabled");
  });

  /*******************************
   * General Inquiries Form
   *******************************/
  $(".general_inquiry_select").change(function () {
    if ($(this).val() == "events") {
      $(".general_inquiry_form_element").hide();
      $("#general_inquiry_atlas_note").fadeIn();
      $("#general_inquiry_security_note").hide();
      $("#general_inquiry_product_advice_note").hide();
      $("#general_inquiry_demo_note").hide();
    } else if ($(this).val() == "security") {
      $(".general_inquiry_form_element").hide();
      $("#general_inquiry_atlas_note").hide();
      $("#general_inquiry_security_note").fadeIn();
      $("#general_inquiry_product_advice_note").hide();
      $("#general_inquiry_demo_note").hide();
    } else if ($(this).val() == "demo") {
      $(".general_inquiry_form_element").hide();
      $("#general_inquiry_atlas_note").hide();
      $("#general_inquiry_demo_note").fadeIn();
      $("#general_inquiry_security_note").hide();
      $("#general_inquiry_product_advice_note").hide();
    } else if ($(this).val() == "product_advice") {
      $(".general_inquiry_form_element").hide();
      $("#general_inquiry_atlas_note").hide();
      $("#general_inquiry_demo_note").hide();
      $("#general_inquiry_product_advice_note").fadeIn();
      $("#general_inquiry_security_note").hide();
    } else {
      $(".general_inquiry_form_element").fadeIn();
      $("#general_inquiry_atlas_note").hide();
      $("#general_inquiry_demo_note").hide();
      $("#general_inquiry_product_advice_note").hide();
      $("#general_inquiry_security_note").hide();
      $("#message").delay(300).focus();
    }
  });

  /*******************************
   * Evaluator Advice Form
   *******************************/

  // when product selection clicked
  $(".jq_product_select .jq_fake_select_options a").on("click", function () {
    var selectedProduct = $(this);
    var productName = selectedProduct.html();
    var productValue = selectedProduct.data("fakeSelectValue");

    // insert product name in all into all placeholder spans
    var productPlaceholder;
    if (
      productValue == "tam" ||
      productValue == "priority_support" ||
      productValue == "premier_support"
    ) {
      productPlaceholder = $("span.jq_product_placeholder").not(
        "span.jq_datacenter_product_placeholder"
      );
    } else {
      productPlaceholder = $("span.jq_product_placeholder");
    }
    archiveAndChangeHtml(productPlaceholder, productName);

    // insert product name into select options
    var productOption = $("option.jq_product_placeholder");
    var productOptionOriginalValue = productOption.data("originalValue");
    if (!productOptionOriginalValue) {
      productOptionOriginalValue = productOption.html();
      productOption.attr("data-original-value", productOptionOriginalValue);
    }
    productOption.html(productOptionOriginalValue + " " + productName);

    // insert product demo
    var demoUrl = productMap["default"].demo_url;
    if (productMap[productValue] && productMap[productValue].demo_url) {
      demoUrl = productMap[productValue].demo_url;
    }
    $("a.jq_demo_link").attr("href", demoUrl);

    // insert trial url
    var trialUrl = productMap["default"].trial_url;
    if (productMap[productValue] && productMap[productValue].trial_url) {
      trialUrl = productMap[productValue].trial_url;
    }
    $("a.jq_trial_link").attr("href", trialUrl);

    // By default show the RFP general Experts instructions and link.
    // IF a custom RFP help link is defined for the product then show the RFP/RFI-specific instructions and links instead.
    var rfpHelpLink = $("a.jq_rfp_help_link");
    if (productMap[productValue] && productMap[productValue].rfp_help_url) {
      rfpHelpLink.attr("href", productMap[productValue].rfp_help_url);
      rfpHelpLink.show();
      $(".jq_rfp_resources_instructions").show();
      $(".jq_rfp_expert_instructions").hide();
      $("a.jq_rfp_experts_link").hide();
    } else {
      $(".jq_rfp_expert_instructions").show();
      $("a.jq_rfp_experts_link").show();
      rfpHelpLink.hide();
      $(".jq_rfp_resources_instructions").hide();
    }

    // IF a custom webinar help link is defined for the product then show the webinar-specific instructions and links instead.
    var webinarLink = $("a.jq_webinar_link");
    if (productMap[productValue] && productMap[productValue].webinar_url) {
      $(".webinar-section").show();
      webinarLink.attr("href", productMap[productValue].webinar_url);
    } else {
      $(".webinar-section").hide();
    }

    // insert tech support url
    var techSupportUrl = productMap["default"].tech_support_url;
    if (productMap[productValue] && productMap[productValue].tech_support_url) {
      techSupportUrl = productMap[productValue].tech_support_url;
    }
    $("a.jq_tech_support_link").attr("href", techSupportUrl);

    // insert product recommender name
    var recommendedBy = productMap["default"].recommended_by;
    if (productMap[productValue] && productMap[productValue].recommended_by) {
      recommendedBy = productMap[productValue].recommended_by;
    }
    $(".jq_recommended_by").html(recommendedBy);

    // insert product recommender avatar
    var avatarImg = productMap["default"].avatar;
    if (productMap[productValue] && productMap[productValue].avatar) {
      avatarImg = productMap[productValue].avatar;
    }
    $("img.jq_avatar").attr("src", avatarImg);
  });

  // when evaluation stage is clicked, see if extra product fields need to be added or hidden
  $("input[name='evaluation_stage']").on("click", function () {
    var selectedEvalStage = $(this).val();
    var selectedProduct = $("input[name='product']").val();

    // handle the premier product field
    var premierProductSection = $("#premier_product_section");
    if (
      selectedEvalStage == "customer" &&
      selectedProduct == "premier_support"
    ) {
      enableFields(premierProductSection);
      premierProductSection.show();
    } else {
      disableFields(premierProductSection);
      premierProductSection.hide();
    }

    // handle the priority product field
    var priorityProductSection = $("#priority_product_section");
    if (
      selectedEvalStage == "customer" &&
      selectedProduct == "priority_support"
    ) {
      enableFields(priorityProductSection);
      priorityProductSection.show();
    } else {
      disableFields(priorityProductSection);
      priorityProductSection.hide();
    }

    // handle the tam product field
    var tamProductSection = $("#tam_product_section");
    if (selectedEvalStage == "customer" && selectedProduct == "tam") {
      enableFields(tamProductSection);
      tamProductSection.show();
    } else {
      disableFields(tamProductSection);
      tamProductSection.hide();
    }
  });

  // when enterprise selection changed, change product placeholder html
  $(
    "select[name='tam_product'],select[name='priority_product'],select[name='premier_product']"
  ).on("change", function () {
    // insert product name in all into enterprise product placeholder spans
    var dcProductName = $(this).find(":selected").html();
    var dcProductPlaceholder = $("span.jq_datacenter_product_placeholder");
    archiveAndChangeHtml(dcProductPlaceholder, dcProductName);

    // insert tech support url
    var productValue = $(this).val();
    var techSupportUrl = productMap["default"].tech_support_url;
    if (productMap[productValue] && productMap[productValue].tech_support_url) {
      techSupportUrl = productMap[productValue].tech_support_url;
    }
    $("a.jq_tech_support_link").attr("href", techSupportUrl);
  });

  // when enterprise placeholder is hidden conditionally, reset the enterprise product placeholder name to default.
  $("[data-select-option-id='customer']").on("conditional-hide", function () {
    var dcProductPlaceholder = $(this).find(
      "span.jq_datacenter_product_placeholder"
    );
    restoreHtml(dcProductPlaceholder);
  });

  // If slider test exists
  if ($("#contactHelpTest").length) {
    // Clicking 'contact us' button moves screen position to form below
    $(".link-to-self-serve")
      .find('a[href="#"]')
      .on("click", function () {
        $("html, body").animate(
          {
            scrollTop: $formSection.offset().top - STICKYNAV_HEIGHT,
          },
          "slow"
        );

        // prefill form with information from self-help
        selfHelpContactUs();

        // focus on email field after auto-filling form.
        var emailField = $("#email");
        setTimeout(function () {
          emailField.focus();
        }, 1000);

        return false;
      });

    $(".kt_test_slide_next").on("click", function (e) {
      handleSlideNext($(this));
      e.preventDefault();
    });

    $(".kt_test_slide_back").on("click", function (e) {
      handleSlideBack($(this));
      e.preventDefault();
    });
  }

  /**
   * Analytics
   */
  function handleSelfHelpLink(target, selfHelpType) {
    var eventProperties =
      cst.support.analytics.getStandardAnalyticsEventProperties(target);
    eventProperties["self-help-type"] = selfHelpType;
    if (selfHelpState.selfHelpPath.length > 0) {
      eventProperties["self-help-path"] = selfHelpState.selfHelpPath;
    }
    var form = $("form.jq_conditional_form");
    Object.assign(
      eventProperties,
      cst.support.analytics.getNonPiiFormDataMap(form)
    );
    tracking.trackEvent("Self-Help Clicked", eventProperties);
  }

  window.segmentPageReady = () => {
    if (cst.support.analytics.checkForSegmentAnalytics()) {
      const purchasingLicensingEventProperties = {
        customerStatus: null,
        customerTopic: null,
        customerPlatform: null,
      };

      // Track reporter status
      $('input[type="radio"][name="reporter_status"]').on("change", (event) => {
        purchasingLicensingEventProperties.customerStatus = $(event.target)
          .parent("label")
          .text();
        tracking.trackEvent("radioItem selected", {
          label: purchasingLicensingEventProperties.customerStatus,
        });
      });

      // Track selection of dropdown menu
      $("[data-fake-select-value]").on("click", (event) => {
        purchasingLicensingEventProperties.customerTopic =
          event.target.textContent;
        tracking.trackEvent("dropListItem selected", {
          label: purchasingLicensingEventProperties.customerTopic,
        });
      });

      // Track buttons inside info-wrap
      $(".info-wrap")
        .find("a.button")
        .on("click", (event) => {
          tracking.trackEvent("button clicked", {
            label: event.target.textContent,
          });
        });

      // Track Billing an licensing form on submit
      $('form[name="ca-billing-licensing"].jq_conditional_form').on(
        "final-submit",
        () => {
          const hostingRadioButtons = $(
            'input[type="radio"][name="hosting"]:visible'
          );
          hostingRadioButtons.each((i, radioButton) => {
            if (radioButton.checked) {
              purchasingLicensingEventProperties.customerPlatform = $(
                radioButton
              )
                .parent("label")
                .text();
            }
          });
          tracking.trackEvent(
            "purchasingLicensingForm submitted",
            purchasingLicensingEventProperties
          );
        }
      );

      // this is our submit event that says that the form has passed validation etc.
      $("form.jq_conditional_form").on("final-submit", function (event) {
        var form = $(event.target);
        var eventProperties =
          cst.support.analytics.getStandardAnalyticsEventProperties(form);

        // see if self-help was offered
        var selfHelpOfferedInline = $(".self-service-opt:visible").length > 0;
        eventProperties["self-help-offered-inline"] = selfHelpOfferedInline;

        var selfHelpOfferedToplevel = $(".js-self-help:visible").length > 0;
        eventProperties["self-help-offered-toplevel"] = selfHelpOfferedToplevel;
        if (selfHelpState.selfHelpPath.length > 0) {
          eventProperties["self-help-path"] = selfHelpState.selfHelpPath;
        }

        // add all of the form name/value pairs as event properties
        Object.assign(
          eventProperties,
          cst.support.analytics.getNonPiiFormDataMap(form)
        );
        tracking.trackEvent("Form Submit", eventProperties);
      });

      // click on top-level self-help
      $("a.js-self-help").on("click", function () {
        var target = $(this);
        handleSelfHelpLink(target, "top-level");
      });

      // click on inline self-help
      $(".self-service-opt a").on("click", function () {
        var target = $(this);
        handleSelfHelpLink(target, "inline");
      });
    }
  };

  //attachment upload input element behavior
  $(".inputfile").each(function () {
    var $input = $(this),
      $label = $input.next("label"),
      labelVal = $label.html();

    $input.on("change", function (e) {
      var fileName = "";

      if (this.files && this.files.length > 1)
        fileName = (this.getAttribute("data-multiple-caption") || "").replace(
          "{count}",
          this.files.length
        );
      else if (e.target.value) fileName = e.target.value.split("\\").pop();

      if (fileName)
        $label.find("span").html(fileName.replace(/(<(\/?[^>]+)>)/g, ""));
      else $label.html(labelVal);
    });

    // Firefox bug fix
    $input
      .on("focus", function () {
        $input.addClass("has-focus");
      })
      .on("blur", function () {
        $input.removeClass("has-focus");
      });
  });

  if (location.hash === "#priority-support-inquiry") {
    $('form[name="pa-evaluation-inquiry"] #product').val("priority_support");
    $('form[name="pa-evaluation-inquiry"] .fake-select.jq_fake_select_field')
      .text("Priority Support")
      .addClass("populated");
    $(
      'form[name="pa-evaluation-inquiry"] div[data-select-option-id="stage"]'
    ).show();
    $('form[name="pa-evaluation-inquiry"] input[name="evaluation_stage"]').prop(
      "checked",
      true
    );
    enableFields(
      $('form[name="pa-evaluation-inquiry"] div[data-select-option-id="stage"]')
    );
    $('form[name="pa-evaluation-inquiry"] #email').focus();
    $(document).scrollTop($(".wac-form").offset().top);
  }

  /**
   * END OF onReady()
   */
});
